import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type CaseStudy = {
  id: string
  slug: string
  title: string
  industry: string | null
  service_type: string | null
  challenge: string | null
  strategy: string | null
  design_notes: string | null
  technology: string | null
  outcome: string | null
  image_url: string | null
  published_at: string | null
  created_at: string
}

export type ContactSubmission = {
  id: string
  name: string
  company: string | null
  email: string
  project_type: string | null
  budget_range: string | null
  timeline: string | null
  message: string | null
  created_at: string
}

export type ContactSubmissionInput = Omit<ContactSubmission, 'id' | 'created_at'>

export type InsightCategory = 'Technology' | 'Business' | 'Product' | 'Data & Intelligence' | 'Digital Commerce'

export type Insight = {
  id: string
  title: string
  slug: string
  category: InsightCategory
  excerpt: string | null
  body_content: string | null
  author: string | null
  cover_image_url: string | null
  published: boolean
  published_at: string | null
  created_at: string
  updated_at: string
}

export type PageView = {
  id: string
  page_path: string
  referrer: string | null
  country: string | null
  device_type: string | null
  session_id: string | null
  created_at: string
}

export type JobStatus = 'draft' | 'published' | 'closed'

export type JobPosition = {
  id: string
  title: string
  slug: string
  department: string | null
  location: string | null
  employment_type: string | null
  description: string | null
  status: JobStatus
  published_at: string | null
  created_at: string
  updated_at: string
}

export type JobApplication = {
  id: string
  position_id: string | null
  position_title: string
  name: string
  email: string
  phone: string | null
  cover_letter: string | null
  resume_path: string | null
  resume_filename: string | null
  created_at: string
}
